import React from "react";

const Marquee = ({ text, className = "", speed = "slow" }) => {
  const items = Array.from({ length: 6 }).map((_, i) => (
    <span key={i} className="mx-8 flex items-center gap-8">
      {text}
      <span className="inline-block w-2 h-2 bg-[#00A651]" />
    </span>
  ));

  return (
    <div className={`overflow-hidden whitespace-nowrap ${className}`}>
      <div
        className={`inline-flex ${
          speed === "slow" ? "animate-marquee-slow" : "animate-marquee"
        }`}
      >
        {items}
        {items}
      </div>
    </div>
  );
};

export default Marquee;
